// extracted by mini-css-extract-plugin
module.exports = {"owner":"styles_owner__iw2mF","notEvents":"styles_notEvents__2FC0L"};